import React, {useEffect, useState} from "react";
import {createUseStyles, useTheme} from "react-jss";
import {Switch, Route, Redirect, useParams} from "react-router-dom";

import TaskCreateEdit from "./TaskCreateEdit/TaskCreateEdit";
// import TasksViewAllTasksTable from "./Tables/TasksViewAllTasksTable";
import TasksTablesTabNavRouter from "./Tables/TasksTablesTabNavRouter";
//eslint-disable-next-line
const styles = createUseStyles((theme) => ({}));

const TaskManagementRouter = (props) => {
    //eslint-disable-next-line
    const theme = useTheme();
    //eslint-disable-next-line
    const classes = styles({...props, theme});

    /***************** CONST ******************/

    /***************** CONST ******************/

    /***************** STATE ******************/

    /***************** STATE ******************/

    /***************** CALLBACK ******************/

    /***************** CALLBACK ******************/

    /***************** EFFECTS ******************/

    /***************** EFFECTS ******************/

    /***************** FUNCTIONS ******************/

    /***************** FUNCTIONS ******************/

    /***************** RENDER ******************/
    return (
        <Switch>
            <Route exact path="/tasktimemanagement/tasks">
                <Redirect to="/tasktimemanagement/tasks/tables" />
            </Route>
            <Route path="/tasktimemanagement/tasks/tables">
                <TasksTablesTabNavRouter />
            </Route>
            <Route path="/tasktimemanagement/tasks/task/edit/:id">
                <TaskCreateEdit />
            </Route>
        </Switch>
    );

    /***************** RENDER ******************/
};

export default TaskManagementRouter;
// <Route exact path="/tasktimemanagement/tasks/time/addentryandtrack">
//                 <TimeCreateEntryMain />
//             </Route>
//             <Route exact path="/tasktimemanagement/tasks/time/manualentry">
//                 <TimeAddManualEntry />
//             </Route>
//             <Route exact path="/tasktimemanagement/tasks/time/viewtimetrack">
//                 <DailyOrganizerTimeTracking />
//             </Route>
